import { render } from "./UserIcon.vue?vue&type=template&id=3899f668&bindings={}"
import script from "./UserIcon.vue?vue&type=script&lang=ts"
export * from "./UserIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script